/**
 * Audio Waveform Animation — shown when someone is transmitting (Talk2 palette).
 */
import React from 'react';
import useStore from '../store/useStore';

const BARS = 24;

export default function AudioWave() {
  const isTransmitting = useStore(s => s.isTransmitting);
  const transmittingUser = useStore(s => s.transmittingUser);
  const user = useStore(s => s.user);

  if (!isTransmitting) return (
    <div className="h-16 flex items-center justify-center px-6">
      <div className="text-[11px] text-n-400 font-semibold tracking-widest uppercase">Canal libre</div>
    </div>
  );

  const isSelf = transmittingUser?.userId === user?.id;
  const color = isSelf ? '#FF2D55' : '#007AFF';
  const tint  = isSelf ? '#FFE5EC' : '#E6F1FF';
  const label = isSelf ? 'Transmitiendo…' : `${transmittingUser?.username} está hablando`;

  return (
    <div className="h-16 flex items-center gap-4 px-6 py-2 animate-fade-in"
      style={{ background: tint, borderBottom: `1px solid ${color}33` }}>
      {/* Avatar */}
      {transmittingUser && (
        <div
          className="w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0 shadow-apple-sm"
          style={{
            background: `linear-gradient(135deg, ${transmittingUser.avatarColor || color}, ${color})`,
          }}
        >
          {transmittingUser.username?.[0]?.toUpperCase() || '?'}
        </div>
      )}

      <div className="flex-1 min-w-0">
        <div className="text-[11px] font-bold mb-1.5 tracking-apple-tight" style={{ color }}>
          {label}
        </div>

        {/* Animated bars */}
        <div className="flex items-end gap-0.5 h-6">
          {Array.from({ length: BARS }).map((_, i) => (
            <div
              key={i}
              className="flex-1 rounded-sm"
              style={{
                background: color,
                opacity: 0.7 + Math.random() * 0.3,
                animationName: 'wave',
                animationDuration: `${0.6 + (i % 7) * 0.1}s`,
                animationTimingFunction: 'ease-in-out',
                animationIterationCount: 'infinite',
                animationDelay: `${(i * 0.04) % 0.5}s`,
                height: '100%',
                transform: 'scaleY(0.4)',
              }}
            />
          ))}
        </div>
      </div>

      {/* Pulsing dot */}
      <div className="w-3 h-3 rounded-full flex-shrink-0"
        style={{ background: color, boxShadow: `0 0 10px ${color}aa`, animation: 'pulse 1s ease-in-out infinite' }} />
    </div>
  );
}
